import React from 'react';
import './ConsentText.less';

export const ConsentText = ({text}) => {
	return <span className="consent-text">{text}</span>
}
